"use strict";

export default class JobForm {
  constructor(){
  }

  initialize(options = {}){
    options.conditionFlagLimit ||= 10;
    this.conditionFlagLimit = options.conditionFlagLimit;
    this.initializeConditionFlags();
  }
  initializeConditionFlags(){
    $('[data-role=condition-flag-checkbox]').on('click', this.updateDisabledStateConditionFlagCheckboxes.bind(this));
    $(document).ready(this.updateDisabledStateConditionFlagCheckboxes.bind(this));
  }
  updateDisabledStateConditionFlagCheckboxes(){
    const checked = $('[data-role=condition-flag-checkbox]:checked');
    const unchecked = $('[data-role=condition-flag-checkbox]:not(:checked)');
    unchecked.prop('disabled', checked.length >= this.conditionFlagLimit);
  }
}
